import React from 'react'
import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const AdvcanceState = (props) => {
    const { datas } = props;
    const state = useSelector((state)=>state)


    const dashboardData = 
    state.SideBarFiles.UserEmailID =="hdfcsales@uds.in" || 
    state.SideBarFiles.UserEmailID =="arcolab@uds.in"||
    state.SideBarFiles.UserEmailID =="sbilife@uds.in"  ?  
    state.StatesOfAdvanceAttendance_particularRecordsCall.StatesOfAdvanceAttendanceparticularRecordsData : 
    state.StatesOfAdvanceAttendanceRecordsCall.StatesOfAdvanceAttendanceRecordsData
    ;

    const stateNames = [...new Set(dashboardData.map(item => item.FilterName))];

    const chartData = stateNames.map(state => {
        const record = dashboardData.find(item => item.FilterName === state);
        return {
            state,
            others: record.employee_count - record.working_count || 0,
            present_count: record.present_count || 0,
            working_count: record.working_count || 0,
        };
    });



    const tableHeaderStyle = {
        padding: "10px",
        // borderBottom: "2px solid #ddd",
        fontWeight: "500",
        background: "#f79c37",
        position: "sticky",
        top: 0,
        color: "#fff",
        fontSize: "14px !important",
        textAlign: "center",
        zIndex: 2

    };

    const tableCellStyle = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "13px",
        textAlign: "center"


    };

    const tableHeaderStyleState = {
        padding: "10px",
        // borderBottom: "2px solid #ddd",
        fontWeight: "500",
        background: "#f79c37",
        position: "sticky",
        top: 0,
        color: "#fff",
        fontSize: "14px !important",
        textAlign: "left",
        zIndex: 2,
        borderRadius: "10px 0px 0px 10px"


    };

    const tableHeaderStyleLastState = {
        padding: "10px",
        // borderBottom: "2px solid #ddd",
        fontWeight: "500",
        background: "#f79c37",
        position: "sticky",
        top: 0,
        color: "#fff",
        fontSize: "14px !important",
        textAlign: "center",
        zIndex: 2,
        borderRadius: "0px 10px 10px 0px"


    };







    return (
        <>

            <div>
                <h5>{datas.state === "" && datas.region === "" && datas.zone === ""
                    ? "All"
                    : datas.state !== "" && datas.region === "" && datas.zone === ""
                        ? "Region"
                        : datas.state !== "" && datas.region !== "" && datas.zone === ""
                            ? "Zone"
                            : datas.state !== "" && datas.region !== "" && datas.zone != "" && "Zone"
                }</h5>

                <div className="NormalTableCalls" style={{ maxHeight: "170px", overflowY: "auto", overflowX: "auto", paddingRight: "12px" }}>
                    <table className="TicketingTableOverviewsDashboard TableOverviewsDashboard" style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: "1" }}>
                            <tr>
                                <th style={tableHeaderStyleState}>{datas.state === "" && datas.region === "" && datas.zone === ""
                                    ? "All"
                                    : datas.state !== "" && datas.region === "" && datas.zone === ""
                                        ? "Region"
                                        : datas.state !== "" && datas.region !== "" && datas.zone === ""
                                            ? "Zone"
                                            : datas.state !== "" && datas.region !== "" && datas.zone != "" && "Zone"}</th>
                                <th style={tableHeaderStyle}>Employee </th>
                                <th style={tableHeaderStyle}>Present </th>
                                {/* <th style={tableHeaderStyle}>Absent Count</th>
                                    <th style={tableHeaderStyle}>Weekoff Count</th> */}
                                <th style={tableHeaderStyleLastState}>Working </th>
                            </tr>
                        </thead>
                        {
                            dashboardData.length > 0 ?
                                <tbody>
                                    {dashboardData.map((item, index) => (
                                        <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
                                            <td style={tableCellStyle} className="LabelNamesstate">{item.FilterName}</td> {/* Filter Name Here */}
                                            <td style={tableCellStyle}>{item.employee_count || 0}</td>
                                            <td style={tableCellStyle}>{item.present_count || 0}</td>
                                            {/* <td style={tableCellStyle}>{item.absent_count || 0}</td>
                                        <td style={tableCellStyle}>{item.weekoff_count || 0}</td> */}
                                            <td style={tableCellStyle}>{item.working_count || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                :
                                <tbody>
                                    <tr key={0} style={{ borderBottom: "1px solid #ccc" }}>
                                        <td colSpan="5" style={tableCellStyle}>{"No data Available"}</td>
                                    </tr>
                                </tbody>
                        }
                    </table>

                </div>
                {chartData.length != 0 ?
                    <div style={{ minWidth: "645px", minHeight: "337px", overflowX: "scroll", marginTop: "25px" }}>
                        <div style={{ width: "1200px", height: "315px" }}> {/* Set a wide fixed width */}
                            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }} width={1200} height={303}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="state"
                                    tick={{ fontSize: 10, dy: 10 }}
                                    interval={0}
                                    angle={-25}
                                    tickFormatter={(value) => value.length > 7 ? `${value.substring(0, 9)}...` : value}
                                />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="present_count" stackId="a" fill="#4CAF50" fontSize={12} name="PRESENT" />
                                <Bar dataKey="working_count" stackId="a" fill="#FFD54F" fontSize={12} name="WORKING" />
                                <Bar dataKey="others" stackId="a" fill="#430bee" fontSize={12} name="OTHERS" />
                            </BarChart>
                        </div>
                    </div>

                    : null}


            </div>


        </>
    )
}

export default AdvcanceState